import { createSlice } from "@reduxjs/toolkit";
import { newGoogleResponse } from "../actions/googleResponseAction";

const internshipSlice = createSlice({
  name: "googleFormResponse",
  initialState: {
    googleformresponse: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(newGoogleResponse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(newGoogleResponse.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.googleformresponse = action.payload;
      })
      .addCase(newGoogleResponse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default internshipSlice.reducer;
